<template>
    <b-modal
        ref="communication-channel-modal"
        :ok-title="$t('Component(Button):back')"
        ok-variant="dark"
        ok-only
        @ok="save"
        centered
        :title="$t('Component(CommunicationChannelModal):label')"
    >
        <b-form>
            <b-form-group
                :label="$t('Component(Label):communication-channel-type')"
                label-for="type"
            >
                <v-select
                    id="type"
                    v-model="type"
                    :placeholder="$t('Component(Placeholder):communication-channel-type')"
                    :options="types"
                    :getOptionLabel="getCommunicationTypeLabel"
                />
            </b-form-group>

            <b-form-group
                :label="$t('Component(Label):communication-channel-value')"
                label-for="name"
            >
                <b-form-input
                    id="name"
                    :placeholder="$t('Component(Placeholder):communication-channel-value')"
                    v-model="channel"
                    @input="onChannelInput"
                />
                <b-collapse :visible="showContactEmailDomainDiffersToOrganizationDomainMessage">
                    <b-alert
                        class="mt-1"
                        variant="warning"
                        show
                    >
                        <div class="alert-body">
                            {{ $t('Component(Text):supplier-contact-domain-differs-with-organization-domain') }}
                        </div>
                    </b-alert>
                </b-collapse>
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>
import {
    BFormGroup, BFormInput, BModal, BForm, BCollapse, BAlert
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import {CommunicationType} from "@/libs/supply-chain";

export default {
    name: 'CommunicationChannelModal',
    components: {
        BModal, BForm, BFormGroup, BFormInput, vSelect, BCollapse, BAlert
    },
    props: {
        expectedDomain: {
            default: null
        },
    },
    data() {
        return {
            type: null,
            channel: null,
            types: CommunicationType.toArray(),
            showContactEmailDomainDiffersToOrganizationDomainMessage: false,
            timeoutId: null
        }
    },
    methods: {
        getCommunicationTypeLabel(type) {
            return this.$t('Enum(CommunicationType):' + type);
        },
        populate(type, channel) {
            this.type = type;
            this.channel = channel;
        },
        onChannelInput() {
            this.showContactEmailDomainDiffersToOrganizationDomainMessage = false;
            if (this.expectedDomain && this.channel && this.type === CommunicationType.EMAIL) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(() => {
                    if (!this.channel.endsWith(this.expectedDomain)) {
                        this.showContactEmailDomainDiffersToOrganizationDomainMessage = true;
                    }
                }, 1000);
            }
        },
        save() {
            this.$emit(
                'save',
                {
                    type: this.type,
                    channel: this.channel,
                }
            );
            this.type = null;
            this.channel = null;
        },
        show() {
            this.$refs['communication-channel-modal'].show();
        },
        hide() {
            this.$refs['communication-channel-modal'].hide();
        },
    },
}
</script>
